const dataSteps = [
  {
    subtitle: 'Получение заявки',
    text: 'Заполните форму, укажите свои данные и отправьте нашим менеджерам в обработку',
    className: 'receiving-application',
  },
  {
    subtitle: 'Консультация',
    text: 'После обработки Вашей заявки, мы связываемся с Вами, выявляем потребности и пожелания, а также проводим техническую консультацию',
    className: 'consultation',
  },
  {
    subtitle: 'Выезд на объект',
    text: 'В назначенное время мы выезжаем на объект и согласовываем основные технические решения, обсуждаем техническое задание',
    className: 'visit-object',
  },
  {
    subtitle: 'Составляем график',
    text: 'На этом этапе мы составляем коммерческое предложение и занимаемся согласованием графика работ (проектирования, закупки оборудования и  монтажа).',
    className: 'chart',
  },
  {
    subtitle: 'Договор',
    text: 'Мы заключаем с Вами договор и начинаем проектирование и согласование проекта',
    className: 'contract',
  },
  {
    subtitle: 'Поставка и монтаж',
    text: 'На этом этапе, происходит поставка всех материалов и начинается выполнение монтажных работ',
    className: 'delivery-installation',
  },
  {
    subtitle: 'Подписание акта выполненных работ',
    text: null,
    className: 'signing-act',
  },
];

export default dataSteps;
